import { Col } from "react-bootstrap";const InfoCol = ({ label, value, highlight, valueStyle = {} }) => {
  let displayValue = value;

  // Handle object values safely
  if (
    value !== null &&
    value !== undefined &&
    typeof value === "object" &&
    !Array.isArray(value)
  ) {
    displayValue =
      value.primary_category ||
      value.top_categories?.[0] ||
      value.label ||
      value.name ||
      "-";
  }

  // Handle null / undefined / empty string
  if (
    displayValue === null ||
    displayValue === undefined ||
    displayValue === ""
  ) {
    displayValue = "-";
  }

  return (
    <Col md={4} style={{ minWidth: 0 }}>
      <div className="text-muted small">{label}</div>

      <div
        className={`fw-semibold ${highlight && !valueStyle.color ? "text-danger" : ""}`}
        style={{
          overflowWrap: "anywhere",
          wordBreak: "break-word",
          whiteSpace: "normal",
          maxWidth: "100%",
          ...valueStyle,
        }}
      >
        {displayValue}
      </div>
    </Col>
  );
};

export default InfoCol;